import {useDispatch, useSelector} from "react-redux";
import {State} from "../store/reducer";
import { getCommonTelephones } from "../service";
import {useEffect} from "react";
import {commonPhones} from "../store/actions";


export default () => {
    const phones = useSelector<State,State['commonPhones']>(state => state.commonPhones)
    const dispatch = useDispatch()

    useEffect(() => {
        if(phones.length === 0){
            getCommonTelephones().then(res => {
                if(res.code === 1){
                    dispatch(commonPhones(res.data))
                }
            })
        }
    },[])
    return phones
}
